module.exports = __webpack_public_path__ + "img/gloria.5725314f.jpeg";